angular.module('FlexyBeautyApp.services')
    .factory('KycStatus_Resource', ["$resource", "$location",
        function ($resource, $location) {
            let baseUrl = $location.protocol() + "://" + $location.host() + ($location.port() && ":" + $location.port()) + "/";
            return $resource(baseUrl + "rest/kyc/status", {}, {
                getKycStatus: {method: "GET"},
            });
        }
    ]);

angular.module('FlexyBeautyApp.services')
    .factory('KycStatusSrv', ["KycStatus_Resource",
        function (KycStatus_Resource) {
            let kycStatusSrv = {};

            kycStatusSrv.getKycStatus = () => {
                return KycStatus_Resource.getKycStatus().$promise;
            };

            return kycStatusSrv;
        }
    ]);



// WEBPACK FOOTER //
// ./js/services/models/KycStatus.js